/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEveFormContainerData } from './eve-form-container.data';
import { IEveFormContainerProps } from './eve-form-container.props.autogenerated';

export interface IEveFormContainerViewProps extends IEveFormContainerProps<IEveFormContainerData> {}

/**
 *
 * EveFormContainer component
 * @extends {React.PureComponent<IEveFormContainerProps<IEveFormContainerData>>}
 */
class EveFormContainer extends React.PureComponent<IEveFormContainerProps<IEveFormContainerData>> {
    constructor(props: IEveFormContainerProps<IEveFormContainerData>) {
        super(props);
    }

    /**
     * This renders the module.
     * @returns JSX.Element | Null
     */
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default EveFormContainer;
